/* lmm-intent-fallback.js — TUEV-13 Zero-Result-Fallback fuer Collectionseiten
   (Chris 2026-08-16)

   PROBLEM
   Der Intent-Router uebersetzt eine technische Suche in eine gefilterte
   Collection. Fehlt der gesuchte Merkmalswert im Sortiment, endete der Kunde
   auf einer toten Seite — das Sicherheitsnetz TUEV-13A existiert nur auf
   /search und greift auf Collectionseiten nicht.

   LEITER (jede Stufe genau einmal, streng monoton lockernd)
     Stufe 0  exakte Interpretation des Routers
     Stufe 1  Farbcode 9xx -> 8xx bei identischer Kelvinzahl (965 -> 865):
              gleiche Lichtfarbe, niedrigere Farbwiedergabeklasse
     Stufe 2  Farbcode entfernen (Sockel, Watt, Technologie bleiben)
     Stufe 3  Watt-/Ersatzwattfilter entfernen (Sockel, Technologie bleiben)
     Stufe 4  zurueck auf den vorhandenen /search-Pfad, dort greift TUEV-13A

   SICHERHEIT GEGEN MANUELLE FILTER
   Die Automatik laeuft ausschliesslich, wenn die drei Marker lmm_iq/lmm_is/
   lmm_ik in der URL stehen UND lmm_ik zur aktuellen filter.*-Menge passt.
   Gesetzt werden die Marker nur von snippets/lmm-search-intent-engine-part-8
   beim Absenden einer Suche. Aendert der Kunde selbst einen Filter, weicht
   die Signatur ab und es passiert nichts. Ein manuell leergefilterter
   Zustand wird also nie automatisch zurueckgesetzt.

   LOOP-SICHERHEIT
   location.replace() erzeugt keine History-Eintraege, lmm_is waechst streng
   monoton, MAX_STUFE deckelt hart, und ein Ziel gleich der aktuellen URL
   bricht ab. Maximal vier Uebergaenge, danach ist Schluss.

   Kein zusaetzlicher Request: die Trefferzahl steht bereits serverseitig im
   gerenderten #lmmResultCount. */
(function () {
  'use strict';

  if (window.__lmmIntentFallbackInit) return;
  window.__lmmIntentFallbackInit = true;

  var P_QUERY = 'lmm_iq';
  var P_STUFE = 'lmm_is';
  var P_SIG = 'lmm_ik';
  var MARKER = [P_QUERY, P_STUFE, P_SIG];
  var K_FARBE = 'filter.p.m.specs.color_code';
  var K_WATT = ['filter.p.m.specs.replaces_wattage', 'filter.p.m.specs.wattage'];
  var MAX_STUFE = 4;
  /* Kanonische Farbcodes des Sortiments: erste Ziffer = Farbwiedergabeklasse,
     letzte zwei Ziffern = Kelvin/100. Identisch zur Router-Erkennung. */
  var FARBCODE = /\b([89])(2[257]|3[035]|40|5[07]|6[05])\b/;

  /* ---- URL-Parameter als rohe Paare, damit die Signatur beidseitig
          bytegleich rechnet (dieselbe Formel wie in part-8) ---------------- */

  function paareLesen(suche) {
    var out = [];
    String(suche || '').replace(/^\?/, '').split('&').forEach(function (teil) {
      if (!teil) return;
      var i = teil.indexOf('=');
      out.push(i === -1 ? [teil, ''] : [teil.slice(0, i), teil.slice(i + 1)]);
    });
    return out;
  }

  function paareSchreiben(paare) {
    return paare.map(function (p) {
      return p[1] === '' ? p[0] : p[0] + '=' + p[1];
    }).join('&');
  }

  function wert(paare, schluessel) {
    for (var i = 0; i < paare.length; i++) {
      if (paare[i][0] === schluessel) return paare[i][1];
    }
    return '';
  }

  function ohne(paare, schluessel) {
    return paare.filter(function (p) { return schluessel.indexOf(p[0]) === -1; });
  }

  function setzen(paare, schluessel, neuerWert) {
    var getroffen = false;
    var out = paare.map(function (p) {
      if (p[0] !== schluessel) return p;
      getroffen = true;
      return [schluessel, neuerWert];
    });
    if (!getroffen) out.push([schluessel, neuerWert]);
    return out;
  }

  function signatur(paare) {
    var text = paare.filter(function (p) {
      return p[0].indexOf('filter.') === 0;
    }).map(function (p) {
      return p[0] + '=' + p[1];
    }).sort().join('&');
    var hash = 5381;
    for (var i = 0; i < text.length; i++) {
      hash = ((hash << 5) - hash + text.charCodeAt(i)) | 0;
    }
    return (hash >>> 0).toString(36);
  }

  function entschluesseln(roh) {
    try { return decodeURIComponent(String(roh || '').replace(/\+/g, ' ')); }
    catch (fehler) { return String(roh || ''); }
  }

  /* ---- Seitenzustand ------------------------------------------------------ */

  /* Serverseitig gerenderte Wahrheit: „Keine Treffer" / „Keine Artikel" bei 0,
     sonst „1–24 von N …". Nie per JS ueberschrieben (siehe Sectionkommentar). */
  function leer() {
    var zaehler = document.getElementById('lmmResultCount');
    if (zaehler) return /^keine\b/i.test((zaehler.textContent || '').trim());
    return !!document.querySelector('.empty-h');
  }

  function markerEntfernen(paare) {
    var rest = ohne(paare, MARKER);
    if (rest.length === paare.length) return;
    var suche = paareSchreiben(rest);
    try {
      history.replaceState(history.state, '',
        location.pathname + (suche ? '?' + suche : '') + location.hash);
    } catch (fehler) { /* ohne History-API bleibt die URL stehen, kein Problem */ }
  }

  /* ---- Hinweis ------------------------------------------------------------ */

  function hinweisText(stufe, paare, anfrage) {
    if (stufe === 1) {
      var farbe = wert(paare, K_FARBE);
      if (!farbe) return '';
      var treffer = FARBCODE.exec(anfrage);
      var gesucht = treffer ? treffer[0] : '9' + farbe.slice(1);
      return 'Für „' + anfrage + '“ gibt es aktuell keinen exakten Treffer. '
        + 'Wir zeigen Alternativen mit derselben Lichtfarbe ' + farbe.slice(1) + '00 K, '
        + 'aber niedrigerer Farbwiedergabe: Farbcode ' + farbe + ' (Ra ≥ 80) statt '
        + gesucht + ' (Ra ≥ 90).';
    }
    if (stufe === 2) {
      return 'Für „' + anfrage + '“ haben wir keine Artikel mit der gewünschten '
        + 'Lichtfarbe gefunden. Wir zeigen passende Artikel mit anderen Lichtfarben.';
    }
    if (stufe === 3) {
      return 'Für „' + anfrage + '“ ist keine exakte Leistungsvariante verfügbar. '
        + 'Wir zeigen weitere passende Alternativen.';
    }
    return '';
  }

  function hinweisZeigen(text) {
    if (!text) return;
    if (document.querySelector('[data-lmm-fallback-hinweis]')) return;
    var anker = document.querySelector('.toolbar');
    if (!anker || !anker.parentNode) return;
    var box = document.createElement('p');
    box.setAttribute('data-lmm-fallback-hinweis', '1');
    box.setAttribute('role', 'status');
    box.style.cssText = 'margin:0 0 12px;padding:10px 14px;border:1px solid #f3ddae;'
      + 'background:#fff6e6;color:#7a5200;border-radius:12px;'
      + 'font-size:.9rem;line-height:1.5;';
    box.textContent = text;
    anker.parentNode.insertBefore(box, anker);
  }

  /* ---- Leiter ------------------------------------------------------------- */

  function naechsteStufe(paare, stufe) {
    var farbe = wert(paare, K_FARBE);
    if (stufe < 1 && farbe && farbe.charAt(0) === '9') {
      return { paare: setzen(paare, K_FARBE, '8' + farbe.slice(1)), stufe: 1 };
    }
    if (stufe < 2 && farbe) {
      return { paare: ohne(paare, [K_FARBE]), stufe: 2 };
    }
    var hatWatt = paare.some(function (p) { return K_WATT.indexOf(p[0]) !== -1; });
    if (stufe < 3 && hatWatt) {
      return { paare: ohne(paare, K_WATT), stufe: 3 };
    }
    return null;
  }

  function start() {
    var paare = paareLesen(location.search);
    var rohAnfrage = wert(paare, P_QUERY);
    if (!rohAnfrage) return;

    var stufe = parseInt(wert(paare, P_STUFE), 10);
    if (!(stufe >= 0) || stufe > MAX_STUFE) stufe = 0;

    /* Signaturbindung: nur die exakt vom Router erzeugte Filtermenge. */
    if (wert(paare, P_SIG) !== signatur(paare)) { markerEntfernen(paare); return; }

    var anfrage = entschluesseln(rohAnfrage);

    if (!leer()) {
      if (stufe > 0) hinweisZeigen(hinweisText(stufe, paare, anfrage));
      markerEntfernen(paare);
      return;
    }

    if (stufe >= MAX_STUFE) { markerEntfernen(paare); return; }

    var naechste = naechsteStufe(paare, stufe);
    if (naechste) {
      var neu = ohne(naechste.paare, ['page']);
      neu = setzen(neu, P_STUFE, String(naechste.stufe));
      neu = setzen(neu, P_SIG, signatur(neu));
      var ziel = location.pathname + '?' + paareSchreiben(neu);
      if (ziel === location.pathname + location.search) { markerEntfernen(paare); return; }
      location.replace(ziel);
      return;
    }

    /* Stufe 4: vorhandener Suchpfad. Das Routing greift nur beim Absenden
       eines Suchformulars, ein direkter Aufruf von /search laeuft also nicht
       erneut in den Router — kein Redirect-Loop. Dort uebernimmt TUEV-13A. */
    location.replace('/search?q=' + encodeURIComponent(anfrage) + '&type=product');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
